/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { openEditBusinessPage, makePremiumFunction, openSendEmailModal }
) {
  return (
    <div className="d-inline-flex align-items-center text-nowrap">
      <OverlayTrigger overlay={<Tooltip id="businesses-edit-tooltip">Edit business</Tooltip>}>
        <a
          href="#"
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={(e) => {
            e.preventDefault();
            openEditBusinessPage(row.id);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} />
          </span>
        </a>
      </OverlayTrigger>

      <OverlayTrigger
        overlay={
          <Tooltip id="businesses-premium-tooltip">
            {row.is_purchased ? "Manage Premium Status (Active)" : "Make Business Premium"}
          </Tooltip>
        }
      >
        <a
          href="#"
          className={`btn btn-icon ${
            row.is_purchased ? "btn-light-warning" : "btn-light"
          } btn-hover-warning btn-sm mx-1`}
          onClick={(e) => {
            e.preventDefault();
            makePremiumFunction(row);
          }}
        >
          <span className={`svg-icon svg-icon-md ${row.is_purchased ? "text-warning" : "svg-icon-primary"}`}>
            <i className={`fa fa-crown ${row.is_purchased ? "text-warning" : "text-muted"}`}></i>
          </span>
        </a>
      </OverlayTrigger>

      <OverlayTrigger overlay={<Tooltip id="businesses-send-email-tooltip">Send custom email</Tooltip>}>
        <a
          href="#"
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={(e) => {
            e.preventDefault();
            openSendEmailModal(row);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <i className="fa fa-envelope text-primary"></i>
          </span>
        </a>
      </OverlayTrigger>
    </div>
  );
}
